module.exports = __webpack_public_path__ + "img/header-717.0413c4e.png";